
import { ScrapReasonModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { scrapReasonsStore } from '@/libs/scrap-reasons/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ScrapReasonDialog from '../components/ScrapReasonDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        ScrapReasonDialog,
    },
})
export default class ScrapReasons extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('scrapReasons.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('scrapReasons.name'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ScrapReasonDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return scrapReasonsStore.useGetter(CrudGetter.Pending);
    }

    get items(): ScrapReasonModel[] {
        return [...scrapReasonsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...scrapReasonsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        scrapReasonsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ScrapReasonModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: ScrapReasonModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
